<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
/**
 * 跨系统（OA/资管等）用 location 跳转后，浏览器后退可能从 bfcache/历史快照
 * 恢复旧的 vuex currentUser（例如先前 SYS 会话），而 cookie fsatoken 已是另一人。
 * pageshow(back_forward|persisted) 时强制 /auth/me 与 cookie 对齐顶栏身份。
 */
export default {
	name: 'App',
	created() {
		this._onPageShow = (e) => {
			const nav = (typeof performance !== 'undefined'
				&& performance.getEntriesByType
				&& performance.getEntriesByType('navigation')[0]) || null;
			const backForward = !!(e && e.persisted)
				|| !!(nav && nav.type === 'back_forward');
			if (!backForward) return;
			const route = this.$route;
			if (route && route.meta && route.meta.public) return;
			this.$store.dispatch('refreshMe').catch((e) => {
				if (e && e.status === 401 && route && !(route.meta && route.meta.public)) {
					this.$router.replace({
						path: '/login',
						query: { redirect: route.fullPath || '/portal' }
					});
				}
			});
		};
		window.addEventListener('pageshow', this._onPageShow);
	},
	beforeDestroy() {
		if (this._onPageShow) {
			window.removeEventListener('pageshow', this._onPageShow);
		}
	}
};
</script>
